import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Modal } from "@/components/Layout";

const TEXT = {
  no_email: "Contul nu are adresă de e-mail, deci codul de verificare nu poate fi trimis.",
  no_smtp: "E-mailul platformei nu este configurat, deci codul de verificare nu poate fi trimis.",
};

export default function ForceMfaLimited() {
  const { user, logout, hasRole } = useAuth();
  if (!user || user === false || !user.mfa_limited) return null;
  const isAdmin = hasRole("admin");
  const out = () => logout().then(() => { window.location.href = "/login"; });
  return (
    <Modal title="Verificarea în doi pași nu este disponibilă" onClose={() => {}} width={520}>
      <div style={{ fontSize: 14, lineHeight: 1.6 }} data-testid="mfa-limited">
        <p style={{ marginTop: 0 }}><b>{TEXT[user.mfa_limited] || "Codul de verificare nu poate fi trimis."}</b></p>
        {user.mfa_limited === "no_smtp" && isAdmin && (
          <p>Configurați <Link to="/admin/smtp" data-testid="goto-smtp">Email (SMTP)</Link> sau opriți temporar verificarea din <Link to="/admin/security" data-testid="goto-security">Securitate</Link>, apoi autentificați-vă din nou.</p>)}
        {user.mfa_limited === "no_smtp" && !isAdmin && <p>Anunțați un Admin să configureze e-mailul platformei (Parametrii, Email SMTP).</p>}
        {user.mfa_limited === "no_email" && <p>Cereți unui administrator să completeze adresa dumneavoastră de e-mail (Utilizatori), apoi autentificați-vă din nou.</p>}
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <button className="btn btn-secondary" onClick={out} data-testid="mfa-limited-logout">Deconectare</button>
      </div>
    </Modal>
  );
}
